import { createMiddleware } from '@shared/redux';
import { BUDGET_MANAGER_TEXTS } from '@domain/dashboard/budget-manager/budget-manager.constants';
import { showSuccessToast } from '@shared/toasts';
import { setModalDraftClusters } from '@domain/budget-manager/modal/budget-manager-campaigns-modal.state';
import { handleGetTagGroupSegmentedReport } from '@domain/segments/tag-groups-segmented/tag-groups-segmented.state';
import { cloneDeep } from 'lodash';
import { handleBudgetManagerErrorToast } from '@domain/omnichannel-budget-manager/omnichannel-budget-manager.middlewares';
import {
    getUpdatedCluster, setUpdatedClusters,
    UPDATE_CLUSTER_REQUEST_CANCELED,
    UPDATE_CLUSTER_REQUEST_FAILED,
    UPDATE_CLUSTER_REQUEST_SUCCEEDED,
} from './update-cluster.state';
import { getClusters, setListClusters } from '../clusters';

export const updateClusterMiddleware = createMiddleware({
    [UPDATE_CLUSTER_REQUEST_SUCCEEDED]: (state) => {
        const clusters = getClusters(state);
        const updatedCluster = getUpdatedCluster(state);
        const updatedClusters = clusters.map(
            cluster => (cluster.id === updatedCluster.id ? updatedCluster : cluster),
        );

        return [
            setListClusters(cloneDeep(updatedClusters)),
            setModalDraftClusters(cloneDeep(updatedClusters)),
            setUpdatedClusters({}),
            handleGetTagGroupSegmentedReport(),
            showSuccessToast({ message: BUDGET_MANAGER_TEXTS.CLUSTER_EDITED_SUCCESSFULLY })];
    },
    [UPDATE_CLUSTER_REQUEST_FAILED]: (state, action) => [
        handleBudgetManagerErrorToast(state, action),
        setUpdatedClusters({}),
    ],
    [UPDATE_CLUSTER_REQUEST_CANCELED]: () => [
        setUpdatedClusters({}),
    ],
});
